<!-- @format -->

@if (activationInformation$ | async; as activationInformation) {
  <app-study-voucher-verify-identity
    data-cy="study-voucher-verify-identity"
    [transactionId]="transactionId()"
    [activationInformation]="activationInformation" />
} @else {
  <sis-loading-screen
    [descriptionKey1]="'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.PROCESSING_PAYMENT_1'"
    [descriptionKey2]="'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.PROCESSING_PAYMENT_2'">
  </sis-loading-screen>
}
